module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('GmapMap', {
    ref: "gmap",
    staticStyle: {
      "width": "100%",
      "height": "615px"
    },
    attrs: {
      "center": {
        lat: 20.5937,
        lng: 78.9629
      },
      "zoom": 16,
      "map-type-id": "roadmap",
      "options": {
        mapTypeControl: false
      }
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6efb5f6e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6efb5f6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/gmapLocation/kmlView.vue
// module id = 2336
// module chunks = 0